import * as React from 'react';
import { cn } from '@/lib/utils';

export { QuestionSidebarChart, QuestionSidebarChartContainer, QuestionSidebarLegends, QuestionSidebarLegend } from './question-sidebar-chart';

export { QuestionSidebarTime, QuestionSidebarClock, QuestionSidebarCount, QuestionSidebarYesterday } from './question-sidebar-stats';

const QuestionSidebarContainer = React.forwardRef(({ className, children, ...props }, ref) => (
  <aside
    ref={ref}
    className={cn('c-question-sidebar-container', 'text-[13px]', 'gap-4', 'flex', 'flex-col', 'w-full', '[&_p]:mb-0', className)}
    {...props}
  >
    {children}
  </aside>
));
QuestionSidebarContainer.displayName = 'QuestionSidebarContainer';

const QuestionSidebarBody = React.forwardRef(({ className, children, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-question-sidebar-body', 'flex', 'flex-col', 'gap-4', 'w-full', className)}
    {...props}
  >
    {children}
  </div>
));
QuestionSidebarBody.displayName = 'QuestionSidebarBody';

const QuestionSidebarSection = React.forwardRef(({ className, children, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-question-sidebar-section', 'bg-white', 'rounded-[10px]', 'p-6', 'border', 'border-solid', 'border-neutral-lightest', 'shadow-sm', 'w-full', className)}
    {...props}
  >
    {children}
  </div>
));
QuestionSidebarSection.displayName = 'QuestionSidebarSection';

const QuestionSidebarTitle = React.forwardRef(({ className, children, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn(
      'c-question-sidebar-title',
      'text-primary-dark',
      'font-extrabold',
      'mb-5',
      'text-base',
      // Estilos aninhados para o span
      '[&_span]:font-light',
      '[&_span]:text-[13px]',
      '[&_span]:text-neutral',
      // Classe para sobrescrever font-size se estiver dentro de __yesterday
      '[&.c-question-sidebar-yesterday]:text-sm',
      className
    )}
    {...props}
  >
    {children}
  </h3>
));
QuestionSidebarTitle.displayName = 'QuestionSidebarTitle';

const QuestionSidebarHighlight = React.forwardRef(({ className, children, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-question-sidebar-highlight', 'text-neutral-darker', 'bg-neutral-lightest', 'rounded-md', 'p-4', 'border', 'border-solid', 'border-neutral-lighter', 'shadow-sm', className)}
    {...props}
  >
    {children}
  </div>
));
QuestionSidebarHighlight.displayName = 'QuestionSidebarHighlight';

const QuestionSidebarHeader = React.forwardRef(({ className, children, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-question-sidebar-header', 'w-full', className)}
    {...props}
  >
    {children}
  </div>
));
QuestionSidebarHeader.displayName = 'QuestionSidebarHeader';

export { QuestionSidebarContainer, QuestionSidebarBody, QuestionSidebarSection, QuestionSidebarTitle, QuestionSidebarHighlight, QuestionSidebarHeader };
